var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitchTablePlanReservations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6969_272202)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#709FAF",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6969_272202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.75 17C24.38 17 23.25 18.52 23.25 20.4C23.25 21.88 23.95 23.11 24.92 23.58L25 23.62V30H26.5V23.62L26.58 23.59C27.55 23.12 28.25 21.89 28.25 20.41C28.25 18.53 27.13 17 25.75 17ZM21.5 17C21.23 17 21 17.22 21 17.5V20H20.25V17.5C20.25 17.22 20.03 17 19.75 17C19.47 17 19.25 17.22 19.25 17.5V20H18.5V17.5C18.5 17.22 18.28 17 18 17C17.72 17 17.5 17.22 17.5 17.5V21.3C17.5 22.23 18.14 23.01 19 23.23V30H20.5V23.23C21.36 23.01 22 22.23 22 21.3V17.5C22 17.22 21.78 17 21.5 17ZM31 15H15V31H31V15ZM31 13C32.1 13 33 13.9 33 15V31C33 32.1 32.1 33 31 33H15C13.9 33 13 32.1 13 31V15C13 13.9 13.9 13 15 13H31Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6969_272202",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6969_272202"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6969_272202",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6969_272202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchTablePlanReservations);
export default __webpack_public_path__ + "static/media/switch_table_plan_reservations.388cc7ab65332b3d7c9a97a8c7c33dde.svg";
export { ForwardRef as ReactComponent };